import Collapse from "@/components/data-display/collapse";
import HorizontalLine from "@/components/data-display/horizontalLine";
import PageBanner from "@/components/data-display/pageBanner";
import MetaData from "@/components/seo/MetaData";
import { faqData } from "@/utils/constants/faq.constants";
import { formatSentence } from "@/utils/helpers";

function FAQ() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/faq`;

  return (
    <>
      <MetaData url={pageUrl} />
      <PageBanner bannerText="Frequently Asked Questions" />

      <div className="container mb-[4.25rem] mt-[3.5rem] md:mb-[8rem]">
        <div className="md:mx-auto md:w-[75%]">
          {faqData.map((faq) => (
            <div key={faq.id}>
              <Collapse
                bodyText={faq.answer}
                headingText={formatSentence(faq.question)}
              />
              <HorizontalLine />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default FAQ;
